import { render, staticRenderFns } from "./workout-by-author-slider.vue?vue&type=template&id=e7d62c8c&"
import script from "./workout-by-author-slider.vue?vue&type=script&lang=js&"
export * from "./workout-by-author-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports